import { Divider } from '@mui/material';
import { ReactNode, Ref, useRef } from 'react';

import { cn } from 'noddi-ui-common';
import { Link } from 'react-router-dom';
import { webButtonStyling } from '../../../theme';
import { ExpandingArrow } from '../Icons';
import { TextOrNode } from './TextOrNode';

type KeyValueRowProps = {
  header: ReactNode;
  value?: ReactNode;
  showDivider?: boolean;
  openInNewTab?: boolean;
  to?: string;
};

export const KeyValueRow = ({ header, value, showDivider = true, to, openInNewTab }: KeyValueRowProps) => {
  const clickable = !!to;

  const arrowRef = useRef<HTMLDivElement | HTMLAnchorElement>(null);

  const RowContent = () => (
    <div>
      <div className='flex items-center justify-between gap-4'>
        <TextOrNode className='text-greyMuted' value={header} />
        <div className='flex items-center'>
          {value && <TextOrNode value={value} />}
          {clickable && <ExpandingArrow parentRef={arrowRef} />}
        </div>
      </div>
      {showDivider && <Divider sx={{ opacity: '1' }} />}
    </div>
  );

  if (to) {
    return (
      <Link
        className={cn(webButtonStyling, 'active:scale-95')}
        to={to}
        target={openInNewTab ? '_blank' : '_self'}
        ref={arrowRef as Ref<HTMLAnchorElement>}
      >
        <RowContent />
      </Link>
    );
  }

  return <RowContent />;
};
